var React = require('react');

function DollyFlatbed (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M450.74 448a48 48 0 1 0 90.52 0zm-288 0a48 48 0 1 0 90.52 0zM592 32H448v128l-48-32-48 32V32H208a16 16 0 0 0-16 16v256a16 16 0 0 0 16 16h384a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 160V32h-96v128l48-32zm176 224H128V16a16 16 0 0 0-16-16H16A16 16 0 0 0 0 16v32a16 16 0 0 0 16 16h48v368a16 16 0 0 0 16 16h544a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

DollyFlatbed.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = DollyFlatbed;

DollyFlatbed.default = DollyFlatbed;
